var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#CDCDCD",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M85 1.111c6.443 0 11.667 5.218 11.667 11.656V70.24c0 6.437-5.224 11.655-11.667 11.655H69.725L50.06 98.89 30.32 81.895H15c-6.443 0-11.667-5.218-11.667-11.655V12.767C3.333 6.329 8.557 1.11 15 1.11h70zM50.567 18.598c-.667-.313-1.461-.026-1.774.64l-6.003 12.79-8.062 1.232-5.496.84c-.276.042-.53.17-.73.364-.527.514-.537 1.358-.023 1.885l9.854 10.1-2.312 14.174c-.048.296.005.598.15.86.356.645 1.167.878 1.811.522L50 55.362l12.018 6.643c.262.145.564.197.86.149.726-.119 1.22-.804 1.1-1.53l-2.311-14.175 9.854-10.1c.195-.2.322-.454.364-.73.111-.728-.389-1.408-1.117-1.52L57.21 32.03l-6.003-12.79c-.132-.283-.359-.51-.64-.641z",
    transform: "translate(-510 -696) translate(510 696)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarEmpty);
export default __webpack_public_path__ + "static/media/star-empty.78a52087.svg";
export { ForwardRef as ReactComponent };